<template>
  <v-page-content>
    <course-book-content editMode />
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CourseBookContent from '@/components/content/education/courses/CourseBookContent.vue'
import RouteMixin from '@/components/helpers/mixins/route-mixin'

export default {
  name: 'EditCoursePage',
  components: {
    CourseBookContent
  },
  mixins: [RouteMixin],
  computed: {
    ...mapGetters({
      isContentSaved: 'contentManager/isContentSaved',
      updater: 'contentManager/getUpdater'
    })
  },
  methods: {
    ...mapActions({
      clearCourseContent: 'education/clearCourseContent'
    }),
    handleRoute(to, from, next) {
      if (!this.isContentSaved && this.updater > 0) {
        // eslint-disable-next-line no-alert
        const answer = window.confirm('Имеются несохранённые изменения. Вы точно хотите закрыть страницу?')
        if (answer) {
          window.onbeforeunload = undefined
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.handleRoute(to, from, next)
    if (this.$_isLeavingCourse(to)) {
      this.clearCourseContent()
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.handleRoute(to, from, next)
  }
}
</script>

<style scoped>

</style>
